(function(jQuery)
{
	jQuery.framework = jQuery.framework || {};
	
	jQuery.framework.checkbox = function()
	{
		jQuery("input[type=checkbox]").each(function()
		{
			chk_checkbox_container = jQuery("<div class='fw_chk_container'></div>");
			chk_checkbox = jQuery("<div class='fw_chk_checkbox'></div>");
			
			jQuery(this).after(chk_checkbox_container);
			jQuery(this).css("display", "none");
			
			original = jQuery(this).detach();
			jQuery(chk_checkbox_container).append(chk_checkbox);
			jQuery(chk_checkbox_container).append(original);
			
			jQuery(chk_checkbox).bind("click", function()
			{
				if(!jQuery(this).hasClass("checked"))
				{
					jQuery(this).addClass("checked");
					jQuery(this).next("input").prop("checked", true);
				}
				else
				{
					jQuery(this).removeClass("checked");
					jQuery(this).next("input").prop("checked", false);
				}
			});
		});
	}
	
})(jQuery);

jQuery(window).load(function()
{
	jQuery.framework.checkbox();
});
